'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import type { TextProps } from './Text.types';

import styles from './Text.module.scss';

export function Text({
  style,
  className,
  font = 'base',
  variety,
  variant,
  children,
  testId = 'ui-text',
  ref,
  ...rest
}: TextProps & { ref?: Ref<HTMLSpanElement> }) {
  return (
    <span
      style={style}
      ref={ref}
      className={classnames(
        styles.text,
        variety && styles[`text--${variety}`],
        variant && styles[`text--${variant}`],
        font && styles[`text--${font}`],
        className,
      )}
      data-testid={testId}
      {...rest}
    >
      {children}
    </span>
  );
}
